import React, { useState } from 'react';
import s1 from "../../assets/images/products/pages/anydb/1.png";
import messyBg from "../../assets/images/products/pages/anydb/2.jpeg";
import ubrs from "../../assets/images/products/pages/anydb/ubrs.svg";
import paperToTable from "../../assets/images/products/pages/anydb/paper-to-tablet.jpg";
import salesServices from "../../assets/images/products/pages/anydb/sales-services.png";
import whoIs from "../../assets/images/products/pages/anydb/who.jpeg";
import LeftRight from "../../components/ui/LeftRight";
import { useTranslation } from "react-i18next";
import { faqs } from "../../constants/data";
import Meta from "../../components/common/Helmet";
import {anyDb} from "../../constants/meta";

const AnyDb = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <Meta
        title={anyDb.title}
        description={anyDb.description}
        canonical={anyDb.canonical}
        keywords={anyDb.keywords}
        ogTitle={anyDb.title}
        ogDescription={anyDb.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto pt-12 space-t-16">
        <LeftRight
          title={t('anyDbPage.anyDbUnified')}
          isLeft={true}
          textWidthClass={'md:w-1/2'}
          textPosition={'justify-center'}
          descriptionPosition={'text-center'}
          descriptionList={[
            t("anyDbPage.unifiedDesc1"),
            t("anyDbPage.unifiedDesc2")
          ]}
          icon={false}
          image={s1}
        />
      </div>

      <div className="md:py-20 py-10">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-center items-center">
            <div className="md:text-3xl lg:text-4xl text-2xl">
              <div>{t("anyDbPage.messy1")} <span className="text-theme-color font-medium">{t("anyDbPage.messy2")}</span></div>
              <div className="md:my-3">{t("anyDbPage.messy3")}</div>
              <div>{t("anyDbPage.messy4")} <span className="text-theme-color font-medium">{t("anyDbPage.messy5")}</span></div>
            </div>
            <div className="overflow-hidden">
              <img src={messyBg} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="md:w-theme-container w-mobile-container mx-auto md:mt-20 rounded overflow-hidden">
        <img src={ubrs} className="w-full mx-auto" alt="" />
      </div>

      <div className="text-xl sm:text-xl md:text-2xl lg:text-4xl xl:text-[2.5rem] flex justify-center items-center my-12 sm:my-16 md:my-20 text-center px-4">
        {t("anyDbPage.connected1")}<span className="text-theme-color font-medium mx-1 md:mx-1.5 lg:mx-2">{t("anyDbPage.connected2")}</span>{t("anyDbPage.connected3")}
      </div>

      <div className="md:w-theme-container w-mobile-container mx-auto md:mt-20 mt-10 rounded overflow-hidden">
        <img src={salesServices} className="w-full mx-auto shadow-xl" alt="" />
      </div>

      <div className="text-xl sm:text-xl md:text-2xl lg:text-4xl xl:text-[2.5rem] flex justify-center items-center my-12 sm:my-16 md:my-20 text-center px-4">
        <span className="text-theme-color font-medium mx-1 md:mx-1.5 lg:mx-2">{t("anyDbPage.customized1")}</span>{t("anyDbPage.customized2")}
      </div>

      <div className="md:w-theme-container w-mobile-container mx-auto md:mt-20 mt-10 rounded overflow-hidden">
        <img src={paperToTable} className="w-full mx-auto shadow-xl" alt="" />
        <div className="md:mt-20">
          <LeftRight
            title={t("anyDbPage.whoTitle")}
            isLeft={true}
            textWidthClass={'md:w-1/2'}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            descriptionList={[
              t("anyDbPage.whoDesc1"),
              t("anyDbPage.whoDesc2")
            ]}
            icon={true}
            image={whoIs}
          />
        </div>

        <div className="max-w-4xl mx-auto px-4 py-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">{t("anyDbPage.faqTitle")}</h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-200">
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex justify-between items-center py-4 text-left"
                >
                  <span className="text-lg font-medium text-gray-800">{t(`anyDbPage.${faq.translateKeys.question}`)}</span>
                  <span className="text-xl text-theme-color transform transition-transform duration-300">
                    {openIndex === index ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    openIndex === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="pb-4 text-gray-600">{t(`anyDbPage.${faq.translateKeys.answer}`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnyDb;
